import ReactEcharts from "echarts-for-react";
import { hexColor } from "../../../../../enums/colors";
import { TbCircleFilled } from "react-icons/tb";
import { t } from "i18next";
import { SummaryPersonUsageRow } from "../../../../../stores/TabsStore";
import { useAppStore } from "../../../../../stores/RootStore";
import { Person } from "../../../../../types/types";

export const PersonLoaded = ({person, data}: {person: Person, data: SummaryPersonUsageRow}) => {
  const {theme} = useAppStore()
  let colorPalette = [hexColor.worked, hexColor.stopped, hexColor.turned_off]

  const getOptions = () => ({
    series: [
      {
        name: `${person.attributes.last_name} ${person.attributes.first_name} ${person.attributes.middle_name}`,
        type: "pie",
        radius: ['55%', '90%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: theme === 'light' ? hexColor.background : hexColor.foreground,
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        labelLine: {
          show: false
        },
        color: colorPalette,
        data: [
          { name: "work", value: data.interaction.worked.seconds, color: hexColor.worked },
          { name: "idle", value: data.interaction.stopped.seconds, color: hexColor.stopped },
          { name: "turned_off", value: data.interaction.off.seconds, color: hexColor.turned_off},
        ],
      },
    ]
  });


  return (
    <div className="flex flex-col w-full text-sm my-4 px-2">
      <div className="grid grid-cols-1 lg:grid-cols-3 my-4 gap-4">
        <div className="flex w-full justify-center lg:px-6">
          <ReactEcharts option={getOptions()} style={{ height: 120, width: 120 }} opts={{renderer: 'svg'}} />
        </div>
        <div className="flex flex-col w-full gap-3 lg:border-l border-border lg:px-6">
          <div className="grid grid-cols-2">
            <div className="flex font-semibold">{t('total_interaction')}</div>
            <div className="flex font-semibold">{data.interaction.total.time}</div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.worked}}/>
                <span className="text-secondary-foreground">{t('interaction_worked')}:</span>
              </div>
              <span className="font-medium text-base">{data.interaction.worked.time} ({((data.interaction.worked.seconds / data.interaction.on.seconds) * 100).toFixed(2)} %)</span>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.stopped}}/>
                <span className="text-secondary-foreground">{t('interaction_stopped')}:</span>
              </div>
              <span className="font-medium text-base">{data.interaction.stopped.time} ({((data.interaction.stopped.seconds / data.interaction.on.seconds) * 100).toFixed(2)} %)</span>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <span className="text-secondary-foreground">{t('interaction_on')}:</span>
              </div>
              <span className="font-medium text-base">{data.interaction.on.time} ({(data.interaction.on.percent * 100).toFixed(2)} %)</span>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <span className="text-secondary-foreground">{t('interaction_off')}:</span>
              </div>
              <span className="font-medium text-base">{data.interaction.off.time} ({(data.interaction.off.percent * 100).toFixed(2)} %)</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col w-full gap-3 lg:border-l border-border lg:px-6">
          <div className="grid grid-cols-2">
            <div className="flex font-semibold">{t('interaction_equipment_count')}</div>
            <div className="flex font-semibold">{data.interactionIds.length}</div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.worked}}/>
                <span className="text-secondary-foreground">{t('interaction_as_manual')}:</span>
              </div>
              <span className="font-medium text-base">{data.manual.total.time} ({(data.manual.total.percent * 100).toFixed(2)} %)</span>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.maintenance}}/>
                <span className="text-secondary-foreground">{t('interaction_as_maintenance')}:</span>
              </div>
              <span className="font-medium text-base">{data.maintenance.total.time} ({(data.maintenance.total.percent * 100).toFixed(2)} %)</span>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.repair}}/>
                <span className="text-secondary-foreground">{t('interaction_as_repair')}:</span>
              </div>
              <span className="font-medium text-base">{data.repair.total.time} ({(data.repair.total.percent * 100).toFixed(2)} %)</span>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.service}}/>
                <span className="text-secondary-foreground">{t('interaction_as_service')}:</span>
              </div>
              <span className="font-medium text-base">{data.service.total.time} ({(data.service.total.percent * 100).toFixed(2)} %)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}